import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';

@NgModule({
    declarations: [
        ToggleSwitchComponent,
        ColorPickerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ToggleSwitchComponent,
        ColorPickerComponent
    ]
})
export class UiChartModule
{ }
